import depo from './depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import axios from 'axios';
import { UserData } from '../store/user.store';
import { Servis } from './Servis';
import { hesapYaz } from './oturumSenkron';
import { mobilKancalar } from './platform';

// Simple JWT decode function
// Safe JWT decode function — returns null for invalid input
function decodeJWT(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (!parts || parts.length < 2) return null;
  try {
    const base64Url = parts[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.warn('JWT decode failed:', error);
    return null;
  }
}

class AuthService {
  login(user) {
    let data = 'grant_type=password&username=' + encodeURIComponent(user.username) + '&password=' + encodeURIComponent(user.password)
    return axios({
      method: 'POST',
      url: this.checkURL() + 'login',
      headers: {
        withCredentials: true,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: (data),
      validateStatus: () => true, // 400 (invalid_grant) dahil tüm durumları resolve et, altta dallanalım — yoksa axios 400'de reject eder ve alttaki userMessage hiç set edilmez
    }).then((response) => {
      if (response.status === 200) {
        const token = response && response.data ? response.data.access_token : null;
        const refreshToken = response && response.data ? response.data.refresh_token : null;
        const expiresIn = response && response.data ? response.data.expires_in : null;

        let expirationTime = null;

        if (token) {
          // Decode only when token string exists and looks like a JWT
          const decoded = decodeJWT(token);
          if (decoded && decoded.exp) {
            expirationTime = decoded.exp * 1000; // exp is in seconds
          } else if (expiresIn) {
            expirationTime = Date.now() + (expiresIn * 1000);
          }

          this.sirketeGecTemizle();
          hesapYaz(response.data.KullaniciAd); // OT-3: öbür sekmeler hesap değişimini buradan anlar
          UserData.dispatch('setaccessToken', { token, expirationTime });
        } else if (expiresIn) {
          // No token but backend returned expiresIn — set expiration if needed
          expirationTime = Date.now() + (expiresIn * 1000);
          // Do not set an access token if none provided
        }

        if (refreshToken) {
          UserData.dispatch('setRefreshToken', refreshToken);
        }
      }
      else {
        // Hata: backend OAuth mesajını (error_description) yüzeye çıkar — googleLogin ile aynı desen
        const msg = (response && response.data && response.data.error_description)
          ? response.data.error_description
          : 'Kullanıcı adı veya şifre hatalı.';
        const err = new Error(msg);
        err.userMessage = msg;
        throw err;
      }
      return response.data;
    })
  }

  // Google ile giriş: FE'den gelen Google id_token'i backend'e yollar,
  // backend doğrular + Kullanici.Mail eşler + şifreyle giriştekiyle AYNI token'ı döner.
  googleLogin(idToken) {
    return axios({
      method: 'POST',
      url: this.checkURL() + 'GoogleLogin',
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify({ IdToken: idToken }),
      validateStatus: () => true, // 999/400 dahil tüm durumları resolve et, altta dallanalım
    }).then((response) => {
      if (response.status === 200 && response.data && response.data.access_token) {
        const token = response.data.access_token;
        const refreshToken = response.data.refresh_token;
        const expiresIn = response.data.expires_in;

        let expirationTime = null;
        const decoded = decodeJWT(token);
        if (decoded && decoded.exp) {
          expirationTime = decoded.exp * 1000;
        } else if (expiresIn) {
          expirationTime = Date.now() + (expiresIn * 1000);
        }

        this.sirketeGecTemizle();
        hesapYaz(response.data.KullaniciAd); // OT-3
        UserData.dispatch('setaccessToken', { token, expirationTime });
        if (refreshToken) {
          UserData.dispatch('setRefreshToken', refreshToken);
        }
        return response.data;
      }

      // Hata: backend iş kuralı mesajını (999/400) yüzeye çıkar
      const msg = (response && response.data)
        ? (typeof response.data === 'string' ? response.data : (response.data.mesaj || response.data.Message))
        : null;
      const err = new Error(msg || 'Google ile giriş başarısız.');
      err.userMessage = msg || 'Google ile giriş başarısız.';
      throw err;
    });
  }

  // Token'in süresi dolup dolmadığını kontrol et
  isTokenExpired() {
    const expirationTime = depo.oku('tokenExpiration');
    if (!expirationTime) {
      return true; // Expiration time yoksa süresi dolmuş say
    }
    return Date.now() > parseInt(expirationTime);
  }

  // Token'in süresi 15 dakikadan az kaldı mı?
  shouldRefreshToken() {
    const expirationTime = depo.oku('tokenExpiration');
    if (!expirationTime) {
      return true;
    }
    const timeUntilExpiry = parseInt(expirationTime) - Date.now();
    const fifteenMinutesInMs = 15 * 60 * 1000;
    return timeUntilExpiry < fifteenMinutesInMs;
  }

  // Refresh token özel endpoint'i (Bearer token gerektirmez).
  // OT-3 (COKLU-OTURUM-PLANI §3.4): sekmeler aynı yenileme anahtarını paylaşır ve anahtar tek
  // kullanımlık — iki sekme aynı anda yenilerse kaybeden eskiden depoyu silip HER sekmeyi düşürüyordu.
  // Artık yenileme tarayıcı genelinde kilitle sırayla yapılır; kilidi alan sekme önce depoya bakar,
  // başka sekme yenilediyse ağa gitmeden onun anahtarını kullanır. Kilit yoksa (eski Safari) ya da yine
  // reddedilirse: depodaki anahtar gönderilenden farklıysa başka sekme kazanmıştır → başarı sayılır.
  refreshAccessToken() {
    const gonderilecek = depo.oku('refreshToken');
    const calis = () => this._yenile(gonderilecek);
    try {
      if (typeof navigator !== 'undefined' && navigator.locks && navigator.locks.request) {
        return navigator.locks.request('hepy-oturum-yenile', calis);
      }
    } catch (e) { /* kilit desteklenmiyor */ }
    return calis();
  }

  // Başka sekme yeniledi mi: depodaki anahtar gönderilenden farklı (ya da bu sekmenin belleği bayat)
  // ve erişim anahtarı geçerli → depodakini belleğe al.
  _baskaSekmeYeniledi(gonderilen) {
    const simdiki = depo.oku('refreshToken');
    const depoToken = depo.oku('token');
    if (!simdiki || !depoToken || this.isTokenExpired()) return false;
    if (simdiki === gonderilen && UserData.getters.getuserData === depoToken) return false;
    UserData.commit('_TOKEN', depoToken);
    UserData.commit('_TOKEN_EXPIRATION', depo.oku('tokenExpiration'));
    UserData.commit('_REFRESH_TOKEN', simdiki);
    return true;
  }

  // OT-3e (G-18): yerel oturum silmenin tek yolu. Kaybeden depoyu silmez — anahtar bu arada başka sekmede
  // yenilendiyse silinmez, bu sekme onu belleğine alıp devam eder (false döner). Silindiyse true: çağıran
  // bu sekmeyi oturum dışı ekrana götürür (oturumSenkron.buSekmeyiOturumDisinaAl).
  // zorla: sunucu oturumu kapattı (aynı tarayıcının tüm sekmeleri aynı oturumu paylaşır) → kontrol yok.
  yerelOturumuSil(gonderilen, zorla = false) {
    const bellek = gonderilen !== undefined ? gonderilen : UserData.getters.getRefreshToken;
    if (!zorla && this._baskaSekmeYeniledi(bellek)) return false;
    depo.sil('user');
    depo.sil('token');
    depo.sil('tokenExpiration');
    depo.sil('refreshToken');
    try { sessionStorage.removeItem('aktifLisansVar'); } catch (e) { /* yoksay */ }
    return true;
  }

  _yenile(gonderilen) {
    if (this._baskaSekmeYeniledi(gonderilen)) return Promise.resolve(true);
    const anahtar = depo.oku('refreshToken');
    if (!anahtar) return Promise.reject(false);
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: this.checkURL() + 'login',  // Refresh token endpoint (same as login, uses grant_type=refresh_token)
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: 'grant_type=refresh_token&refresh_token=' + encodeURIComponent(anahtar)
      }).then((response) => {
        if (response.status === 200) {
          const token = response.data.access_token;
          const refreshToken = response.data.refresh_token;
          const expiresIn = response.data.expires_in;

          const decoded = decodeJWT(token);
          let expirationTime = null;

          if (decoded && decoded.exp) {
            expirationTime = decoded.exp * 1000;
          } else if (expiresIn) {
            expirationTime = Date.now() + (expiresIn * 1000);
          }

          // OT-3: OT'den önce açılmış oturumlarda hesap anahtarı yok — ilk yenilemede yazılır.
          if (response.data.KullaniciAd && !this._ortakHesap()) hesapYaz(response.data.KullaniciAd);

          // Yeni token'ları kaydet
          UserData.dispatch('setaccessToken', { token, expirationTime });
          if (refreshToken) {
            UserData.dispatch('setRefreshToken', refreshToken);
          }

          resolve(true);
        } else {
          reject(false);
        }
      }).catch((error) => {
        // Kaybeden depoyu silmez: anahtar bu arada başka sekmede yenilendiyse onunla devam.
        if (this._baskaSekmeYeniledi(anahtar)) return resolve(true);
        console.error('Token refresh hatası:', error);
        if (error && error.response && error.response.status === 404) {
          console.error('Refresh endpoint not found (404). Clearing stored tokens.');
          // OT-3e: çağıran (ensureRefreshed → Servis) bu sekmeyi de oturum dışına alır.
          this.yerelOturumuSil(anahtar);
        }
        reject(error);
      });
    });
  }

  _ortakHesap() {
    try { return localStorage.getItem('oturumHesap'); } catch (e) { return null; }
  }

  logout() {
    // YS2: token zaten yok/süresi dolmuşsa backend'e istek atma — [Authorize] uç zaten 401
    // dönüyordu, yalnız konsolda gereksiz kırmızı satır bırakıyordu.
    const gecerliToken = !!depo.oku('token') && !this.isTokenExpired();
    // MOB M2-b: uygulamada cihazın push kaydını sil — token silinmeden önce (Servis başlığı çağrı anında okur).
    if (gecerliToken && mobilKancalar.cikis) { try { mobilKancalar.cikis(); } catch (e) { /* sessiz */ } }

    // Sadece client-side token temizle — backend kapalı olsa bile sessizce çıkış yap
    depo.sil('user');
    depo.sil('token');
    depo.sil('tokenExpiration');
    depo.sil('refreshToken');
    if (!depo.sirketeGecSekmesi()) hesapYaz(null);
    sessionStorage.removeItem('aktifLisansVar');
    this.sirketeGecTemizle();

    // Backend logout endpoint'ini atmayı dene (başarısız olursa umursama)
    if (gecerliToken) {
      try {
        Servis("GET", "logout", "").catch(() => { /* sessiz */ });
      } catch (e) { /* sessiz */ }
    }
  }

  checkURL() {
    let TokenURL = null;
    if (process.env.NODE_ENV === 'production') {

      TokenURL = 'https://api.hepy.app/api/'
    }
    else {
      TokenURL = 'https://localhost:44386/api/'
    }
    return TokenURL;
  }

  // TEST: Token'in süresi 15 dakikaya kadar azalt (test için)
  simulateTokenExpiring() {
    const expirationTime = depo.oku('tokenExpiration');
    if (!expirationTime) {
      console.warn('Token expiration bulunamadı');
      return;
    }
    
    // 10 dakika öncesine ayarla (refresh trigger olacak)
    const tenMinutesInMs = 10 * 60 * 1000;
    const newExpirationTime = Date.now() + tenMinutesInMs;
    depo.yaz('tokenExpiration', newExpirationTime);
    console.log('✓ Token süresi simüle edildi. Şimdi 15 dakika içinde expire olacak.');
    console.log('Kalan süre:', Math.floor((newExpirationTime - Date.now()) / 60000), 'dakika');
  }

  // TEST: Manuel olarak refresh token'ı test et
  testRefreshToken() {
    console.log('🔄 Refresh token test başlıyor...');
    const refreshToken = depo.oku('refreshToken');
    
    if (!refreshToken) {
      console.error('❌ Refresh token bulunamadı! Lütfen önce login olun.');
      return;
    }

    console.log('📝 Refresh token:', refreshToken.substring(0, 20) + '...');
    console.log('📝 Authorization header \'bearer token\' şeklinde gönderiliyor...');
    
    return this.refreshAccessToken()
      .then(() => {
        console.log('✅ Token başarı ile yenilendi!');
        console.log('Yeni token:', depo.oku('token').substring(0, 20) + '...');
        return true;
      })
      .catch((error) => {
        console.error('❌ Token refresh hatası:', error);
        return false;
      });
  }

  // TEST: Token ve expiration info göster
  getTokenInfo() {
    const token = depo.oku('token');
    const refreshToken = depo.oku('refreshToken');
    const expirationTime = depo.oku('tokenExpiration');

    if (!token) {
      console.log('❌ Token bulunamadı. Lütfen login olun.');
      return null;
    }

    const now = Date.now();
    const expTime = parseInt(expirationTime);
    const timeDiff = expTime - now;
    const minutesLeft = Math.floor(timeDiff / 60000);
    const secondsLeft = Math.floor((timeDiff % 60000) / 1000);

    const info = {
      token: token.substring(0, 30) + '...',
      refreshToken: refreshToken ? refreshToken.substring(0, 30) + '...' : 'Yok',
      expirationTime: new Date(expTime).toLocaleString('tr-TR'),
      timeLeft: `${minutesLeft}m ${secondsLeft}s`,
      shouldRefresh: this.shouldRefreshToken(),
      isExpired: this.isTokenExpired()
    };

    console.table(info);
    return info;
  }

  // register(user) {
  //   return axios.post(API_URL + 'signup', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password
  //   });
  // }

  // SK-S: "Şirkete Geç" — kiracı için dönen kısa ömürlü impersonation token'ı devreye alınır.
  // OT-6 (COKLU-OTURUM-PLANI §3.7): token yalnız BU sekmenin sessionStorage'ına yazılır (depo.js
  // impSekme kipi); ortak depodaki sağlayıcı oturumu ve yenileme anahtarı olduğu gibi kalır —
  // sağlayıcının öbür sekmeleri kiracıya geçmez, "Konsola dön" yalnız sekme anahtarını siler.
  // Kipte refreshToken okunmaz: sağlayıcının anahtarıyla sessiz geri dönüş olmaz, süre dolunca 401 kalır.
  sirketeGecAktifMi() {
    return sessionStorage.getItem('impSekme') !== null || sessionStorage.getItem('impOriginalToken') !== null;
  }

  // Yeni giriş/çıkışta eski "Şirkete geç" kalıntısı temizlenir — impersonation token'ının süresi
  // dolup yeniden giriş yapılınca bayrak sekmede kalıyor, sağlayıcı oturumu kiracı sanılıyordu.
  sirketeGecTemizle() {
    ['impSekme', 'impToken', 'impTokenExpiration', 'impOriginalToken', 'impOriginalTokenExpiration', 'impOriginalRefreshToken', 'impBilgi']
      .forEach((k) => sessionStorage.removeItem(k));
  }

  sirketeGecBilgi() {
    if (!this.sirketeGecAktifMi()) return null;
    try {
      return JSON.parse(sessionStorage.getItem('impBilgi') || 'null');
    } catch (e) {
      return null;
    }
  }

  sirketeGecBaslat(pSirket) {
    return Servis('POST', 'SetSistemSirketeGec', { pSirket }).then((res) => {
      if (res.status === 200 && res.data && res.data.access_token) {
        sessionStorage.setItem('impBilgi', JSON.stringify({
          SirketAdi: res.data.SirketAdi || '',
          SaglayiciAdi: res.data.SaglayiciAdi || '',
          KullaniciAd: res.data.KullaniciAd || '',
          Rol: res.data.Rol || '',
        }));

        const token = res.data.access_token;
        const expiresIn = res.data.expires_in;
        const decoded = decodeJWT(token);
        let expirationTime = null;
        if (decoded && decoded.exp) {
          expirationTime = decoded.exp * 1000;
        } else if (expiresIn) {
          expirationTime = Date.now() + (expiresIn * 1000);
        }

        // Kip önce açılır: setaccessToken → depo.yaz('token') sekme deposuna yazar.
        sessionStorage.setItem('impSekme', '1');
        UserData.dispatch('setaccessToken', { token, expirationTime });
        UserData.commit('_REFRESH_TOKEN', null);

        return true;
      }

      const msg = (res && res.data && (res.data.mesaj || res.data.Message))
        ? (res.data.mesaj || res.data.Message)
        : (typeof res.data === 'string' ? res.data : 'Şirkete geçilemedi.');
      const err = new Error(msg);
      err.userMessage = msg;
      throw err;
    });
  }

  sirketeGecBitir() {
    // İmpersonation token hâlâ aktifken çıkış logunu at — best-effort, başarısız
    // olsa bile asıl oturuma dönüşü engellemesin.
    return Servis('POST', 'SetSistemSirketeGecCikis', '').catch(() => { /* sessiz */ }).then(() => {
      // OT-6 öncesi açılmış geçiş (asıl oturum sessionStorage'da saklanmıştı) — eski yoldan geri yaz.
      const origToken = sessionStorage.getItem('impOriginalToken');
      const origExpiration = sessionStorage.getItem('impOriginalTokenExpiration');
      const origRefresh = sessionStorage.getItem('impOriginalRefreshToken');

      this.sirketeGecTemizle();

      if (origToken) {
        UserData.dispatch('setaccessToken', { token: origToken, expirationTime: origExpiration ? parseInt(origExpiration) : null });
        if (origRefresh) UserData.dispatch('setRefreshToken', origRefresh);
        return true;
      }

      // OT-6: sekme anahtarı silindi → ortak depodaki sağlayıcı oturumu yeniden belleğe.
      UserData.commit('_TOKEN', depo.oku('token'));
      UserData.commit('_TOKEN_EXPIRATION', depo.oku('tokenExpiration'));
      UserData.commit('_REFRESH_TOKEN', depo.oku('refreshToken'));
      return true;
    });
  }
}

export default new AuthService();